import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { createPdf, getContractById } from "../../../reducers/modules/Contratto";
import {
  getContractList,
  getContractProduct,
  saveContract,
  getCompanyDataFromVat,
} from "../../../reducers/modules/Contratto";
import { Loader } from "../../shared/Loader/Loader";
import api from "../../../api/index";
import axios from "axios";
import { FaFilePdf, FaMinus, FaPlus } from "react-icons/fa";
import { isMobile } from "react-device-detect";
import { API_CONTRACT_URL } from "../../../config";
import { CgSearch } from "react-icons/cg";

import "./NuovoContratto.css";

const formFields = [
  { label: "vatCode", isRequired: true, searchable: true },
  { label: "companyName", isRequired: true, searchable: false },
  { label: "legalRepresentative", isRequired: true, searchable: false },
  { label: "legalAddress", isRequired: true, searchable: false },
  { label: "operativeAddress", isRequired: true, searchable: false },
  { label: "taxCode", isRequired: true, searchable: false },
  { label: "phone", isRequired: true, searchable: false },
  { label: "cell", isRequired: true, searchable: false },
  { label: "emails", isRequired: true, searchable: false },
  { label: "pec", isRequired: true, searchable: false },
  { label: "iban", isRequired: false, searchable: false },
  { label: "sdiCode", isRequired: true, searchable: false },
  { label: "operationalContact", isRequired: true, searchable: false },
  // "address",
  // "zipcode",
  // "city",
  // "province",
  // "country",
];
class Contratto extends Component {
  state = {
    isNew: true,
    error: false,
    noProductsSelected: false,
    products: [],
    filesName: [],
    contractProduct: {},
    selectedProducts: {},
    loading: false,
    errorString: "",
  };

  componentDidMount = async () => {
    this.setState({ loading: true });
    const isNew = this.props.match.params.id === "nuovo";
    if (!isNew) {
      const response = await this.props.getContractById(this.props.match.params.id);
      const contratto = response.data;
      this.setState({
        isNew: false,
        ...contratto,
      });
    } else {
      // carico l'elenco dei prodotti che compono il contratto
      const contractProduct = await this.props.getContractProduct(localStorage.getItem("token"));
      // inserisco i valori iniziali per evitare l'errore
      const initialValues = formFields.reduce((acc, curr) => {
        return {
          ...acc,
          [curr.label]: "",
        };
      }, {});
      this.setState({ ...initialValues, contractProduct: contractProduct.data, loading: false });
    }
  };

  saveContract = async (contractData, isPriceQuotation = false) => {
    this.setState({ creatingContract: true });
    const result = await this.props.saveContract(contractData, isPriceQuotation);
    const { payload } = result;
    if (
      payload &&
      (payload.id || (payload.status === 504 && payload.response.message === "redirect_to_list"))
    ) {
      this.props.history.push("/ListaContratti");
    } else {
      this.setState({ error: true });
    }
    this.setState({ creatingContract: false });
  };

  goBack = () => {
    if (this.state.isNew) this.props.history.push("/Dispatcher");
    else this.props.history.push("/ListaContratti");
  };

  handleSubmit = async (isPriceQuotation = false) => {
    this.setState({ noProductsSelected: false });
    const contractData = {
      companyName: this.state["companyName"],
      taxCode: this.state["taxCode"],
      emails: this.state["emails"],
      legalRepresentative: this.state["legalRepresentative"],
      legalAddress: this.state["legalAddress"],
      operativeAddress: this.state["operativeAddress"],
      vatCode: this.state["vatCode"],
      phone: this.state["phone"],
      cell: this.state["cell"],
      emails: this.state["emails"],
      pec: this.state["pec"],
      iban: this.state["iban"],
      sdiCode: this.state["sdiCode"],
      operationalContact: this.state["operationalContact"],
      products: Object.values(this.state.selectedProducts).filter(
        (field) => field !== "" && !!field
      ),
    };

    if (contractData.products.length === 0) {
      this.setState({ noProductsSelected: true });
    } else {
      await this.saveContract(contractData, isPriceQuotation);
    }
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleChangeContractProducts = (event) => {
    this.setState({
      selectedProducts: { ...this.state.selectedProducts, [event.target.name]: event.target.value },
    });
  };

  renderSelect = (arrayProduct, stateField) => {
    if (!arrayProduct) {
      return null;
    } else {
      return (
        <select
          name={stateField}
          id={stateField}
          onChange={this.handleChangeContractProducts}
          style={{
            width: "100%",
            border: "1px solid #ccc",
            height: 38,
            borderRadius: isMobile ? 0 : 4,
          }}
        >
          <option value="">--- Seleziona ---</option>
          {arrayProduct.map((singleProduct) => (
            <option value={singleProduct.codprodotto}>{`${singleProduct.nomeProdotto} - ${
              singleProduct.valoreCompetenza ? "€ " + singleProduct.valoreCompetenza : ""
            }`}</option>
          ))}
        </select>
      );
      // }
    }
  };

  renderSelectName = (name) => {
    switch (name) {
      case "LI":
        return "Licenza";
      case "GS":
        return "Google Shopping";
      case "BL":
        return "Blog";
      case "NL":
        return "News Letter";
      case "FB":
        return "Facebook";
      case "BA":
        return "Banner";
      case "NX":
        return "Nexi";
      case "FE":
        return "Feedaty";
      case "WA":
        return "Whatsapp";
      case "FD":
        return "Farmadati";
      default:
        return name;
    }
  };

  renderSelects = () => {
    const selects = Object.entries(this.state.contractProduct);
    const width = isMobile ? "100%" : "45%";
    return selects.map((arrSelect) => {
      return (
        <div
          className="form-group"
          style={{ flex: 1, flexBasis: width, maxWidth: width, marginRight: isMobile ? 0 : "5%" }}
        >
          <label>{this.renderSelectName(arrSelect[0])}</label>
          <div className="label-element">{this.renderSelect(arrSelect[1], arrSelect[0])}</div>
        </div>
      );
    });
  };

  isDisabled = () => {
    const isBeingCreated = !!this.state.creatingContract;
    const areFieldsCompiled = formFields.every(({ label }) =>
      formFields.isRequired ? !!this.state[label] && this.state[label] !== "" : true
    );
    const isAnyProductSelected =
      Object.values(this.state.selectedProducts).filter((field) => field !== "" && !!field).length >
      0;
    return isBeingCreated || !areFieldsCompiled || !isAnyProductSelected;
  };

  renderFieldName = (name) => {
    switch (name) {
      case "companyName":
        return "Ragione Sociale";
      case "vatCode":
        return "P.IVA";
      case "emails":
        return "Email";
      case "address":
        return "Indirizzo";
      case "zipcode":
        return "CAP";
      case "city":
        return "Città";
      case "province":
        return "Provincia";
      case "country":
        return "Stato";
      case "legalRepresentative":
        return "Rappresentante Legale";
      case "legalAddress":
        return "Indirizzo sede legale";
      case "operativeAddress":
        return "Indirizzo sede operativa";
      case "taxCode":
        return "Codice Fiscale";
      case "phone":
        return "Telefono Società";
      case "cell":
        return "Cellulare";
      case "pec":
        return "Pec Mail";
      case "iban":
        return "IBAN";
      case "sdiCode":
        return "SDI (Codice Univoco)";
      case "operationalContact":
        return "Referente Operativo";
      default:
        return name;
    }
  };

  renderTextInputs = () => {
    const width = isMobile ? "100%" : "45%";
    return formFields.map(({ label, isRequired, searchable }) => (
      <div
        className="form-group"
        style={{ flex: 1, flexBasis: width, maxWidth: width, marginRight: isMobile ? 0 : "5%" }}
      >
        <label htmlFor={label}>{`${this.renderFieldName(label)}${isRequired ? "*" : ""}`}</label>
        <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
          <input
            disabled={!this.state.isNew}
            id={label}
            name={label}
            type={"text"}
            value={this.state[label]}
            className="form-control"
            onChange={this.handleChange}
            placeholder={
              searchable
                ? `Cerca una ${this.renderFieldName(label)}`
                : `Inserisci ${this.renderFieldName(label).toLowerCase()}`
            }
          />
          {searchable && this.state.isNew && (
            <div style={{ marginLeft: isMobile ? 8 : 16 }}>
              <button
                type="submit"
                className="btn btn-primary"
                style={{
                  backgroundColor: "#39fbc7",
                  border: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: isMobile ? 0 : 8,
                }}
                onClick={this.getDataByVat}
                disabled={this.state.loading}
              >
                <CgSearch style={{ fontSize: 20 }} />
              </button>
            </div>
          )}
        </div>
        {this.state.errorString !== "" && searchable && (
          <div style={{ color: "red" }}>{this.state.errorString}</div>
        )}
      </div>
    ));
  };

  handleSendContract = async () => {
    this.setState({ sendingContract: true });
    const contractId = this.props.match.params.id;
    const { method, endpoint, headers } = api.sendContract(contractId);
    try {
      await axios({
        url: endpoint,
        method,
        headers,
      });
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
    this.setState({ sendingContract: false });
  };

  remind = async () => {
    this.setState({ reminding: true });
    const contractId = this.props.match.params.id;
    const { method, endpoint, headers } = api.remindContract(contractId);
    try {
      await axios({
        url: endpoint,
        method,
        headers,
      });
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
    this.setState({ reminding: false });
  };

  renderProducts = () => {
    const productFieldsToShow = [
      "codprodotto",
      "valoreCompetenza",
      "competenza",
      "fatturazione",
      "durataContratto",
      "numeroRate",
      "valoreContratto",
      "nomeProdotto",
      "descrizione",
    ];
    if (isMobile) {
      return this.state.products
        .sort((a, b) => (a.codprodotto > b.codprodotto ? 1 : -1))
        .map((product) => (
          <MobileProduct product={product} productFieldsToShow={productFieldsToShow} />
        ));
    }
    return (
      <table>
        <thead>
          <tr className="header-table">
            {productFieldsToShow.map((key) => (
              <th id={key}>
                <div style={{ textTransform: "capitalize" }}>
                  {key.split(/(?=[A-Z])/).join(" ")}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody style={{ fontSize: 16 }}>
          {this.state.products
            .sort((a, b) => (a.codprodotto > b.codprodotto ? 1 : -1))
            .map((product) => {
              return (
                <tr>
                  {productFieldsToShow.map((key) => (
                    <th>{`${key.includes("valore") ? "€ " : ""}${
                      product[key] ? product[key] : ""
                    }`}</th>
                  ))}
                </tr>
              );
            })}
        </tbody>
      </table>
    );
  };

  getActionButtonData = () => {
    switch (this.state.status) {
      case "SENT":
        return {
          onClick: this.remind,
          loading: this.state.reminding,
          label: "Manda remind",
        };
      case "CREATED":
        return {
          onClick: this.handleSendContract,
          loading: this.state.sendingContract,
          label: "Invia per la firma",
        };
      default:
        return null;
    }
  };

  renderActionButton = () => {
    const data = this.getActionButtonData();
    return (
      data && <ActionButton onClick={data.onClick} loading={data.loading} label={data.label} />
    );
  };

  getDataByVat = async () => {
    this.setState({ loading: true, errorString: "" });

    // se non hanno inserito una partita iva mostro errore e blocco
    if (!this.state.vatCode) {
      this.setState({ errorString: "Inserisci una P.IVA", loading: false });
      return;
    }

    const res = await getCompanyDataFromVat(this.state.vatCode);
    const data = res?.data;

    if (data) {
      if (res?.meta?.count === 0) {
        this.setState({ errorString: "Nessun risultato trovato" });
      } else {
        this.setState({
          companyName: data.companyName,
          legalRepresentative: data.legalRepresentative,
          legalAddress: data.legalAddress,
          operativeAddress: data.operativeAddress,
          taxCode: data.taxCode,
          vatCode: data.vatCode,
          phone: data.phone,
          cell: data.cell,
          emails: data.emails,
          pec: data.pec,
          sdiCode: data.sdiCode,
          operationalContact: data.operationalContact,
        });
      }
    }

    this.setState({ loading: false });
  };

  render() {
    // console.log("props", this.props);
    // console.log("state", this.state);
    return (
      <div className="nuovo-contratto">
        <div
          className="page-header"
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: isMobile ? "flex-start" : "space-between",
            alignItems: isMobile ? "flex-start" : "center",
            gap: isMobile ? 8 : 0,
          }}
        >
          {!this.state.isNew ? "Contratto n°" + this.props.match.params.id : "Nuovo contratto"}
        </div>
        <div>
          <div style={{ display: "flex", flexWrap: "wrap" }}>{this.renderTextInputs()}</div>
        </div>
        {!this.state.isNew ? (
          <div>
            <div style={{ marginTop: 40, cursor: "none!important" }}>
              <div style={{ marginBottom: 16 }}>
                <b>Prodotti</b>
              </div>
              {this.renderProducts()}
            </div>
            <div style={{ marginTop: "40px" }}>
              <div>
                <b>Contratti</b>
              </div>
              <div
                style={{
                  display: "flex",
                  // flexDirection: "column",
                  flexWrap: "wrap",
                  gap: 16,
                  marginTop: 16,
                }}
              >
                {this.state.filesName.map((elem) => (
                  <FileButton elem={elem} />
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div style={{ marginTop: 40, display: "flex", flexWrap: "wrap" }}>
            {this.renderSelects()}
          </div>
        )}

        <div style={this.state.isNew ? { marginTop: "40px" } : { marginTop: "22px" }}>
          {this.state.error && (
            <div style={{ color: "red", fontSize: "14px", marginTop: "16px" }}>
              Vearificare i campi compilati
            </div>
          )}
          {this.state.noProductsSelected && (
            <div style={{ color: "red", fontSize: "14px", marginTop: "16px" }}>
              Selezionare almeno un prodotto
            </div>
          )}
          <div
            className={
              this.state.isNew
                ? "contratto-button nuovo-contratto-btn"
                : "contratto-button contratto-esistente"
            }
            style={{ marginTop: 64, flexDirection: isMobile ? "column" : "row", gap: 16 }}
          >
            <button
              type="button"
              className="btn btn-primary"
              style={{
                border: "1px solid #39fbc7",
                backgroundColor: "white",
                color: "#39fbc7",
                borderRadius: isMobile ? 0 : 8,
              }}
              onClick={this.goBack}
            >
              Torna indietro
            </button>
            {!this.state.isNew && this.renderActionButton()}
            {this.state.isNew && (
              <button
                disabled={this.isDisabled()}
                onClick={() => this.handleSubmit(true)}
                type="button"
                className="btn btn-primary"
                style={{
                  backgroundColor: "#39fbc7",
                  border: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: isMobile ? 0 : 8,
                }}
              >
                {this.state.creatingContract ? <Loader /> : "Crea preventivo"}
              </button>
            )}
            {this.state.isNew && (
              <button
                disabled={this.isDisabled()}
                onClick={this.handleSubmit}
                type="button"
                className="btn btn-primary"
                style={{
                  backgroundColor: "#39fbc7",
                  border: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: isMobile ? 0 : 8,
                }}
              >
                {this.state.creatingContract ? <Loader /> : "Crea e invia per la firma"}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const FileButton = ({ elem }) => {
  return (
    <a
      href={API_CONTRACT_URL + elem.url.trim()}
      target={"_blank"}
      style={{
        backgroundColor: "#eee",
        borderRadius: isMobile ? 0 : 8,
        padding: "8px 12px",
        textDecoration: "none",
        color: "black",
        fontSize: 14,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        // flex: 1,
        // flexBasis: "45%",
      }}
    >
      <FaFilePdf />
      {elem.name}
    </a>
  );
};

const ActionButton = (props) => {
  return (
    <button
      type="button"
      className="btn btn-primary"
      style={{
        backgroundColor: "#39fbc7",
        border: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: isMobile ? 0 : 8,
      }}
      onClick={props.onClick}
    >
      {props.loading ? <Loader /> : props.label}
    </button>
  );
};

const MobileProduct = ({ product, productFieldsToShow }) => {
  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = () => setExpanded(!expanded);
  return (
    <div
      style={{
        backgroundColor: "#f5f5f5",
        marginBottom: 16,

        padding: "8px 16px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div
          onClick={toggleExpanded}
          style={{ fontWeight: "bold" }}
        >{`${product.codprodotto} - €${product.valoreCompetenza}`}</div>
        <div onClick={toggleExpanded}>{expanded ? <FaMinus /> : <FaPlus />}</div>
      </div>
      {expanded && (
        <div onClick={toggleExpanded} style={{ marginTop: 8 }}>
          {productFieldsToShow.map((key) => (
            <div style={{ textTransform: "capitalize" }}>
              <b>{key.split(/(?=[A-Z])/).join(" ")}:</b>{" "}
              {`${key.includes("valore") ? "€ " : ""}${product[key] ? product[key] : ""}`}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  createPdf,
  getContractList,
  getContractProduct,
  saveContract,
  getContractById,
  getCompanyDataFromVat,
})(Contratto);
